module.exports = __webpack_public_path__ + "img/bg.8efa4c8b.png";